var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuelTypeEco24 = function SvgFuelTypeEco24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6h14M7.005 6H19v5.041c0 1.58-.632 3.096-1.757 4.214A6.021 6.021 0 0 1 13 17v0a6.021 6.021 0 0 1-4.243-1.745A5.938 5.938 0 0 1 7 11.04V6h.005ZM10 2v4m6-4v4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 23h7.626a3.342 3.342 0 0 0 2.39-1.004A3.413 3.413 0 0 0 13 19.574V17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.976 11.023-2.24 3.894a.15.15 0 0 1-.067.065.171.171 0 0 1-.096.017.198.198 0 0 1-.078-.016.182.182 0 0 1-.064-.045.153.153 0 0 1-.039-.138l.417-2.38a.146.146 0 0 0-.007-.07.16.16 0 0 0-.037-.06.178.178 0 0 0-.062-.039.192.192 0 0 0-.075-.012h-1.444a.199.199 0 0 1-.09-.022.178.178 0 0 1-.067-.06.157.157 0 0 1-.006-.164l2.24-3.91a.153.153 0 0 1 .066-.065.174.174 0 0 1 .096-.017.196.196 0 0 1 .142.06.152.152 0 0 1 .039.138l-.416 2.382a.16.16 0 0 0 .042.134.19.19 0 0 0 .062.044c.024.01.05.017.076.018h1.445a.196.196 0 0 1 .092.02.174.174 0 0 1 .07.06.153.153 0 0 1 0 .166Z",
    fill: "currentColor"
  })));
};
export default SvgFuelTypeEco24;